import { render, staticRenderFns } from "./OpenVla.vue?vue&type=template&id=7714e04f"
import script from "./OpenVla.vue?vue&type=script&lang=js"
export * from "./OpenVla.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports